import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import Head from "../../Head/Head";
import NavBar from "../../NavBar/NavBar";
import ContactUs from "../../Forms/ContactUs/ContactUs";
import Footer from "../../Footer/Footer";
import Prefer from "../../Prefer/Prefer";
import Offices from "../../Offices/Offices";
import InstantQuote from "../../InstantQuote/InstantQuote";

import HeroImg from "../../../images/template-hero.png";
import HeroBanner from "../../../images/template-hero.jpg";

import LanguagesContents from "../../../data/languages";

import "./TranslationTemplate.css";

const TranslationTemplate = ({ language, location }) => {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const languageType = language
    .split(" ")
    .map((lang) => lang.charAt(0).toUpperCase() + lang.slice(1))
    .join(" ");

  const locationCap = location
    .split(" ")
    .map((lang) => lang.charAt(0).toUpperCase() + lang.slice(1))
    .join(" ");

  useEffect(() => {
    const checkLanguage = (lang) => {
      return lang.name.toLowerCase() === languageType.toLowerCase();
    };
    if (LanguagesContents.find(checkLanguage)) setOpen(true);
    else history.replace("/404");
  }, [history, languageType]);

  return (
    <>
      {open && (
        <div className="template position-relative">
          <Head
            title={`${languageType} simultaneous interpretation services in ${locationCap} | certified ${languageType} interpreters in ${locationCap}`}
            description={`Get ${languageType} simultaneous interpretation services in ${locationCap} with top certified ${languageType} interpreters in ${locationCap}. We offer ${languageType} simultaneous interpretation services in ${locationCap} in over 250 languages.`}
            keywords={`translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations, ${languageType}, ${locationCap}`}
          />
          <NavBar />
          <div className="template__hero container overflow-hidden d-flex f-50 align-center justify-between position-relative z-1">
            <div className="f-50 my-40">
              <div className="d-flex flex-column align-start justify-center">
                <h2 className="font-heading text-capitalise">
                  Professional {languageType} interpretation at Your Finger Tips
                </h2>
                <p className="font-bigger mt-40">
                  We provide {languageType} interpretation at the most
                  professional level bearing client specifics and interest at
                  the core of our services.
                </p>
                <a
                  href="/quote"
                  className="template__link mt-40 py-10 px-20 font-bold"
                >
                  REQUEST A QUOTE
                </a>
              </div>
            </div>
            <div className="d-flex flex-row-reverse justify-end overflow-hidden f-50">
              <img className="d-flex" src={HeroImg} alt="" />
            </div>
          </div>
          <img className="template__banner my-20" src={HeroBanner} alt="" />
          <div className="template__sec1 container d-flex flex-column align-center justify-between">
            <div className="">
              <h2 className="font-heading">
                {languageType} Translation services in {locationCap}{" "}
              </h2>
              <p className="my-40 lh-lg font-heavy">
                Oneconverse offer certified {languageType} document translation
                services in {locationCap}. They have been doing so since 2006
                and they have a wide range of experience as well as highly
                skilled and certified {languageType} translators in LondonFrench
                is one of the most spoken languages in the world so working with
                them can be a big step towards successful business abroad.{" "}
              </p>
              <p className="my-40 lh-lg font-heavy">
                {languageType} translation services in {locationCap} is a new
                and growing industry. Oneconverse offer the best certified{" "}
                {languageType}
                document translation services in {locationCap}.{languageType}
                translation services in
                {locationCap} are important for globalization. Oneconverse offer
                certified {languageType} document translation services in{" "}
                {locationCap}. With employers, multinationals, small businesses,
                and the public sector all making use of their service,
                Oneconverse are one of the most sought-after companies for{" "}
                {languageType} translation services in LondonWe are proud to
                have served clients from over 250 countries including South
                Africa, Australia, USA, Canada and more!{" "}
              </p>
              <a
                href="/quote"
                className="template__link my-40 py-10 px-20 font-bold"
              >
                REQUEST A QUOTE
              </a>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Looking for certified {languageType} translation services in{" "}
                  {locationCap}?
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse is a certified {languageType} translation service
                  provider in {locationCap}. We offer translations in{" "}
                  {languageType} to English and other 250 languages. They are
                  used by companies that need to send out documents to different
                  countries or for individuals who want the documents translated
                  into their native language.{languageType} Translation Services
                  in {locationCap} - Oneconverse can help you with your document
                  translation services. Oneconverse is a certified{" "}
                  {languageType} translation company in
                  {locationCap} that provides the best {languageType} document
                  translation services in {locationCap}{" "}
                </p>
                <p className="lh-lg font-heavy">
                  There are many {languageType} Translation Services in{" "}
                  {locationCap} - At Oneconverse, we understand how important it
                  is for your customer's document to be translated accurately
                  and on time! We provide you with quality {languageType}{" "}
                  document translation services at affordable rates so you don't
                  have to worry about anything!The rise in demand for{" "}
                  {languageType} translation services in
                  {locationCap} has been a result of the language's increased
                  popularity. This is partly because of improved education
                  opportunities and the fact that more people want to live in
                  {locationCap}.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  This has led to an increase in demand for qualified{" "}
                  {languageType}
                  translators and translations services, with some companies
                  such as Oneconverse offering such on their website.
                  Oneconverse also offer certified {languageType} document
                  translation services, which helps businesses save money on
                  expensive foreign translations by having them translated by
                  certified professionals instead.The demand for {languageType}{" "}
                  translation services is likely to increase further with time
                  and so can the introduction of new technologies that continue
                  to evolve and mesh with advances in language study and
                  understanding.Oneconverse offers {languageType} translation
                  services to international businesses and individuals. Whether
                  you need to translate documents into or from {languageType} or
                  use Certified
                  {languageType} Translation in {locationCap}, you can get help
                  with your needs today.
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Certified {languageType} Translation Agency in {locationCap}
                </h2>
                <p className="lh-lg font-heavy">
                  Oneconverse is a {languageType} translation agency that offers
                  certified {languageType} translation services in {locationCap}
                  . It has been active in the industry for over a decade and is
                  proud to be one of the few fully-certified {languageType}{" "}
                  translation agencies in
                  {locationCap}.Oneconverse is a professional, certified, and
                  reliable translation agency which offers all kinds of content
                  from business to legal, from technical to marketing. It also
                  provides support for any language combination.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse is a certified {languageType} translation agency
                  in
                  {locationCap}. They offer document translations of all types.
                  They have qualified translators who are specialists in their
                  fields, so they can help with any project on time and on
                  budget.Oneconverse offers certified {languageType}{" "}
                  translations of various documents including birth
                  certificates, marriage certificates, death certificates,
                  company documents, diplomas and more. Their team of
                  specialists uses proven techniques to provide fast turnaround
                  times on all orders.The company also offers services for
                  Translation of Business Documents for Companies in{" "}
                  {locationCap}. They ensure that the end-result is accurate and
                  compliant with your standards. This ensures that you can focus
                  more on your business rather than worrying about the language
                  barrier of your customers or employees{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse, a certified {languageType} translation agency in{" "}
                  {locationCap}, provides {languageType} translation services.
                  They are known for providing high-quality translation services
                  with an affordable price. Oneconverse is London’s leading{" "}
                  {languageType}
                  translation agency providing the best certified {languageType}
                  translations in the industry. With over 18 years of experience
                  translating documents, Oneconverse has grown into a trusted
                  partner for some of the largest corporations globally.Over the
                  years, Oneconverse has developed a tailor-made solution to
                  meet client’s needs. It provides translations from both sides
                  of the language barrier with its Spanish and English versions
                  on its website and app which are designed to increase
                  efficiency and consistency of delivery.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse offers certified {languageType} translation
                  services in
                  {locationCap}. They offer all kinds of translation services
                  such as Certified {languageType} Translation, Certified{" "}
                  {languageType}
                  Translation Services, and even certified English translator in
                  {locationCap}.Certified {languageType} translation agency in{" "}
                  {locationCap} is a growing industry that offers professional
                  and accurate services for both native and non-native speakers
                  of the language.
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Official {languageType} translation services in {locationCap}{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  At Oneconverse, we are the best at what we do. Our team of
                  {languageType} translators can translate documents to{" "}
                  {languageType} and over 250 languages. We have certified all
                  our translations with the official government agency in France
                  - Notaries Public.{languageType}
                  translation services in {locationCap} is a complex process,
                  which is why it’s important for you to work with a company
                  that has officially certified translators, who have passed
                  rigorous tests to ensure they are competent.At Oneconverse,
                  our team of certified {languageType} document translation in{" "}
                  {locationCap} ensures your documents are translated correctly
                  and remain compliant with copyright laws.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  At Oneconverse, we offer {languageType} translation services
                  in
                  {locationCap}. We provide certified {languageType} document
                  translation in
                  {locationCap}. Our certified {languageType} translation
                  service in {locationCap} is very important for any business
                  looking to expand their global operations.Certified
                  translations are the most reliable way of ensuring that you
                  get quality translations that will give your company the
                  visibility it deserves.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  France has the largest population of native English speakers
                  in Europe. There is a large demand for {languageType}{" "}
                  translation services in {locationCap}. At Oneconverse, we
                  translate documents to {languageType} and over 250 languages
                  ensuring that all our translations are certified as such. We
                  provide certified
                  {languageType} document translation for the European Market as
                  well as document translation into over 250 languages for
                  businesses looking to expand their global presence.This
                  introduction gives an overview of what Oneconverse offer and
                  how they make sure their translations are certified by a third
                  party company
                </p>
                <p className="lh-lg font-heavy">
                  A lot of people in {locationCap} are looking for{" "}
                  {languageType}
                  translation services. At Oneconverse, we provide certified
                  {languageType} document translation in {locationCap}. Our
                  experienced linguists are available to help you with your
                  document translation needs.Oneconverse is an established
                  business that has been successfully serving the requirements
                  of international agencies and individuals for more than ten
                  years. Our certified {languageType} document translation
                  services are delivered by our highly qualified translators who
                  have their own skill sets and market expertise{" "}
                </p>
                <p className="lh-lg font-heavy">
                  At Oneconverse, we provide certified {languageType}{" "}
                  translations in
                  {locationCap}. We certify all our translations, which means
                  that the quality of your translation is guaranteed by an
                  independent third-party.We also specialize in translating
                  documents to {languageType} and over 250 languages so you
                  don't have to worry about sending over your documents in the
                  wrong language.
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  Certified {languageType} Translation Services in {locationCap}{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  At Oneconverse, we offer the best {languageType} translations
                  in
                  {locationCap}. We are a certified {languageType} translation
                  service that provides certified {languageType} document
                  translation in the city. Our team of translators translates
                  over 250 languages, so you can be sure that when you choose
                  Oneconverse for your translation needs, you are choosing the
                  best possible solution.As one of the few accredited
                  translators in {locationCap}, we are able to translate to over
                  250 languages and certify all our translations. We offer
                  fixed-price services and flexible options for large-scale
                  projects which is why we're trusted by over 20,000 businesses
                  across Europe.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  We take pride in our work and hope that this introduction
                  piques your interest enough to learn more about us!Our Subject
                  Matter Experts will bring the content accuracy and relevance
                  to engage your audience. Oneconverse provides Certified{" "}
                  {languageType}
                  to English translation services in {locationCap}, Accurate and
                  reliable certified {languageType} translation services in{" "}
                  {locationCap} for all type of documents and languages that is
                  ready for publishing. Oneconverse have professional{" "}
                  {languageType}
                  translators who have the background and qualification to
                  translate from English to {languageType} and {languageType} to
                  English or from other languages into {languageType} or from{" "}
                  {languageType} into other languages for a wide range of
                  documents in various fields of industry.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  We can translate {languageType} into over 250 other languages
                  for you! Oneconverse offers worldwide translation services at
                  great prices. Oneconverse employs certified {languageType}{" "}
                  translators who have provided hundreds of clients with premium
                  quality technical translation, each tailored to meet the
                  client's needs. We review each translation carefully to ensure
                  that it meets the quality standards required of our clients.
                  We also use this same process for all documents before
                  delivery.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  You can be sure that Oneconverse will prove to be a great help
                  to your business.{" "}
                </h2>
                <ul className="lh-lg font-heavy ml-20">
                  <li>
                    We have been a leading translation agency in France for a
                    while offering a wide range of translations including{" "}
                    {languageType}
                    to English, German to English and many more. With over 8
                    years of translation experience, we keep ourselves updated
                    with all the latest changes in technology and marketing
                    trends. Our turnaround times are fast and our prices are
                    low!
                  </li>
                  <li>
                    Cost Savings upto 30% compared with any other service
                    provider.
                  </li>
                </ul>
                <p>
                  Our native {languageType} translation team consists of
                  experienced and certified translators that specialize in
                  fields such as Medical, Technical, Financial, Legal
                  Translation.
                  <br />
                  We Offer {languageType} Certified translation Services for
                </p>
                <ul className="lh-lg font-heavy ml-20">
                  <li>Driver Licenses</li>
                  <li>Personal Correspondence</li>
                  <li>School Certificates</li>
                  <li>Passport</li>
                  <li>Immunization Cards</li>
                  <li>Medical Reports</li>
                  <li>Police Clearances</li>
                  <li>Court Orders</li>
                  <li>Technical Manuals</li>
                  <li>Medical Manuals</li>
                  <li>Employee Manuals</li>
                  <li>Birth Certificates</li>
                  <li>Marriage Certificates</li>
                  <li>Divorce Certificates</li>
                  <li>Death Certificates</li>
                </ul>
                <p className="lh-lg font-heavy">
                  Our {languageType} translators can certify all translations
                  they have undertaken so you can be sure of the quality of our
                  work. We also offer services for {languageType}{" "}
                  interpretation, voice-overs, transcriptions, and multilingual
                  search engine optimization. No matter what your {languageType}{" "}
                  Language needs is, Oneconverse can provide them for you.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="">
              <div>
                <h2 className="font-heading py-40">
                  YOUR OFFICIAL {languageType} TRANSLATORS IN {locationCap}
                </h2>
                <ul className="lh-lg font-heavy ml-20">
                  <li>100% Acceptance</li>
                  <li>Certified Translators</li>
                  <li>Notary Services</li>
                  <li>Highest Reviewed in Google</li>
                  <li>30 Minutes Response time</li>
                  <li>Priority Delivery</li>
                  <li>Supports 250 Languages to English</li>
                  <li>Experienced Customer Support</li>
                </ul>
              </div>
            </div>
          </div>
          <Prefer />
          <Offices />
          <ContactUs />
          <div className="container">
            <InstantQuote />
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default TranslationTemplate;
